import api from "./API";
import {Rota} from "../Types/Rota";

export async function getRota(date: Date): Promise<Rota[] | null> {
    try {
        const response = await api.get("/api/unihouse/get/rota?date=" + date.toISOString());
        const rota: Rota[] = response.data.map((item: any): Rota => ({
            id: item.id,
            housemate: item.housemate,
            date: new Date(item.date),
            job: {
                id: item.job.id,
                name: item.job.job,
            }
        }));
        if (rota.length === 0) {
            return null;
        }
        return rota;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function randomiseRota(week: Date): Promise<void> {
    try {
        await api.post("/api/unihouse/randomise/rota", {
            date: week.toISOString(),
        });
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function deleteRotaEntry(rotaId: number): Promise<void> {
    try {
        await api.delete("/api/unihouse/delete/rota/" + rotaId);
    } catch (error) {
        console.error(error);
        throw error;
    }
}